import apiSheltersMap from '@/api/shelters-map'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createSheltersMapStart: '[create sheltersMap] Create sheltersMap start',
  createSheltersMapSuccess: '[create sheltersMap] Create sheltersMap success',
  createSheltersMapFailure: '[create sheltersMap] Create sheltersMap failure',
}

export const actionTypes = {
  createSheltersMap: '[create sheltersMap] Create sheltersMap',
}

const mutations = {
  [mutationTypes.createSheltersMapStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createSheltersMapSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createSheltersMapFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.createSheltersMap](context, sheltersMap) {
    context.commit(mutationTypes.createSheltersMapStart)
    return new Promise((resolve) => {
      apiSheltersMap
        .createSheltersMap(sheltersMap)
        .then((response) => {
          context.commit(mutationTypes.createSheltersMapSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createSheltersMapFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
